'use client';

import type { ChipGlobalFilterItem } from '@weberus/shared-types';
import { Chip, SubHeader } from '@yanolja-rnd/nol-design-system';

interface ChipTypeFilterProps extends ChipGlobalFilterItem {
  onClick: (idx: number) => void;
}

export const ChipTypeFilter: React.FC<ChipTypeFilterProps> = ({ title, items, onClick }) => {
  const hasSelectedItems = items.some((item) => item.selected);

  return (
    <section className="px-16 pt-16">
      <SubHeader.Small title={title} showDotBadge={hasSelectedItems} />
      <div className="flex flex-wrap gap-8 pb-32">
        {items.map((item, idx) => (
          <Chip
            key={idx}
            selected={item.selected}
            leftIcon={!!item.iconUrl && <img src={item.iconUrl} alt={item.title} width={20} height={20} />}
            size="medium"
            theme="outlined"
            onClick={() => {
              onClick(idx);
            }}>
            {
              <div className="relative inline-block">
                {/* 투명 텍스트로 공간 확보 */}
                <span className="invisible font-bold" aria-hidden="true">
                  {item.title}
                </span>
                {/* 실제 렌더링될 텍스트 */}
                <span className="absolute left-0 whitespace-nowrap">{item.title}</span>
              </div>
            }
          </Chip>
        ))}
      </div>
    </section>
  );
};
